export type JudgeGroups = Record<string, string[]>;

export type PointTypes = Record<string, { valueTypes?: { key: string }[] }>;

/**
 * The point type a judge belongs to, resolved from the profile's judgeGroups.
 */
export function pointTypeOfJudge(judgeGroups: JudgeGroups | undefined, judgeCode: string): string | undefined {
  return Object.keys(judgeGroups ?? {}).find((pointType) => judgeGroups[pointType].includes(judgeCode));
}

/**
 * Keys a judge's values are stored under, in the order the criteria are declared. Profiles up to and including the
 * 2025 season name the criteria positionally (value1..valueN), the 2026 ones name them semantically, so the key
 * always has to come from the profile rather than from the position.
 */
export function valueKeys(pointTypes: PointTypes | undefined, pointType: string | undefined): string[] {
  const valueTypes = (pointType ? pointTypes?.[pointType]?.valueTypes : undefined) ?? [];
  return valueTypes.map((valueType) => valueType.key);
}
